/********************
 ACTION TYPES
 ********************/

export const CHECK_RESET = "CHECK_RESET";
export const CHECK_RESET_RESPONSE = "CHECK_RESET_RESPONSE";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_RESPONSE = "RESET_PASSWORD_RESPONSE";